import { addItemToCollection } from "directus/src/operations";

export async function createTimesheetUnlocksItem({ item }) {
  try {
    const query = {
      fields: ["id", "status", "date"],
    };
    const data = await addItemToCollection("timesheet_unlocks", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
